export const MenuSource = {
  HOME: 'Inicio',
  ABOUTUS: 'Quiénes Somos',
  SERVICE: 'Servicios',
  SERVICED: 'Servicios que ofrecemos',
  OURCLIENTS: 'Dónde encontrarnos',
  CONTACT: 'Contacto',
};
